<template>
    <div class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg w-50-xl" v-cloak>

        <DialogTitle :title="serviceAccount.id == null ? $t('Add Service Account') :serviceAccount.name"
            :defaultTitle="serviceAccount.id == null ? $t('Add Service Account') : $t('Edit/Test Service Account')"
            :subTitle="serviceAccount.type_name" @closeDialog="$root.$emit('CLOSESERVICEACCOUNTDIALOG')" />

        <div class="dialog-content overflow bg-light">

            <!--------------------------FORM--------------------------------------------->

            <div class="form-group">
                <label>{{ $t("Name") }}</label>
                <input data-role="input" type="text" v-model.trim="serviceAccount.name" maxlength="50"
                    :placeholder="$t('enter name')" data-prepend="<span class='mif-pencil'></span>" />
                
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="cell-6">
                        <label>Username</label>
                        <input data-role="input" class="metro-input" type="text" v-model.trim="serviceAccount.username"
                            :placeholder="$t('Enter Username')" data-prepend="<span class='mif-person'></span>" />
                        
                    </div>
                    <div class="cell-6">
                        <label>{{ $t("Password") }}*</label>
                        <input v-if="[null, ''].includes(serviceAccount.id)" class="metro-input" data-role="input" type="password" v-model.trim="serviceAccount.password" :placeholder="$t('Enter Password')" v-no-autocomplete="'mif-lock'" />
                        <input v-else class="metro-input" data-role="input" type="password" data-reveal-button="false" data-prepend="<span class='mif-lock'></span>" value="**********" disabled/>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="cell-8">
                        <label>{{ $t("Server") }}</label>
                        <input data-role="input" type="text" v-model.trim="serviceAccount.url"
                            :placeholder="$t('Enter Address')" data-prepend="<span class='mif-cloud'></span>" />
                        
                    </div>
                </div>
            </div>
            <!-------------------------------SCELTA PC----------------------------------------->
            <div v-if="$session.getRoomPC() == null" class="form-group">
                <label>
                    <span>{{ $t("Select PC to Test Service Account") }}</span>
                </label>
                <select class="select cell-9" v-model="testPC" :disabled="$session.getPCList().length == 0">
                    <option :data-append="pc.description" v-for="pc in $session.getPCList()" :value="pc"
                        :disabled="!$root.connectionsStates[pc.id]" v-bind:key="pc.id"> {{ pc.pc_name }}
                    </option>
                </select>
            </div>
        </div>

        <!-------------------------------TEST ACCOUNT----------------------------------------->
        <div class="dialog-actions d-flex">

            <div v-if="tested == TEST_WAIT"><span class="mif-spinner2 ani-spin" /></div>

                <button class="button bg-amber" @click="test" :disabled="!enableTest" v-disable-tooltip="$t('Edit connection credentials before testing the account.')">{{ $t("Test account") }}</button>
                <button class="button secondary" :disabled="!enableSave" @click="saveServiceAccount(serviceAccount)" v-disable-tooltip="$t('You can save the account only if the account test is successful.')">{{ $t("Save") }}</button>
            </div>
    </div>
</template>

<script>
import DialogTitle from "../../utils/DialogTitle.vue";
import { draggableMixin } from '../../../mixins/draggable-mixin'
import { saveServiceAccount, testServiceAccount } from "../../../utils/entityMethods/serviceAccount";


export default {
    mixins: [draggableMixin],
    name: "ESXIServiceAccount",
    components: {
        "DialogTitle": DialogTitle,
    },
    props: {
        serviceAccount: Object,
    },
    data() {
        return {
            testPC: null,

            // -1 : avviato
            // 0 : non avviato o fallito
            // 1 : ok
            tested: 0,
            TEST_NOTOK : 0,
            TEST_WAIT : -1,
            TEST_OK : 1,
        }
    },
    computed: {
        allInputCompleted() {
            
            return this.serviceAccount.name != "" && (this.$session.getRoomPC() != null || this.testPC != null) && 
                this.serviceAccount.url != "" &&
                this.serviceAccount.username != "" &&
                this.serviceAccount.password != "";
        },
        enableTest() {
            return this.allInputCompleted && this.tested == this.TEST_NOTOK;
        },
        enableSave() {
            return this.allInputCompleted && (this.tested == this.TEST_OK || this.tested== this.TEST_NOTOK && this.serviceAccount.id != null);
        }

    },
    created(){
        if(this.serviceAccount.options.lastTestPC !=null)
            this.testPC = this.$session.getPCWithID(this.serviceAccount.options.lastTestPC);
        },

    methods: {
        saveServiceAccount,
        testServiceAccount,

        async test() {
            var testResult = await this.testServiceAccount(this.serviceAccount, this.testPC);
            this.tested = testResult.okNumber;
        }
    }
}

</script>
